import { useRef, useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import { isApartSkillActive } from '@/utils/Page';
import s from './style.module.scss';
import { changeHorizonDomIntoView } from '@/utils/Page';
const TopSkillList = (props) => {
    const { skillStore, chatStore } = props.store;
    const boxRef = useRef(null);

    const { skillList = [], isNewChat = true, toolList, changeTool, curToolId } = props;
    const { curSkill } = skillStore;
    const { choseApartSkill } = chatStore;
    const handleSetCurSkill = (item) => {
        if (choseApartSkill) {
            choseApartSkill(item);
        }
    };
    const changeScroll = (skill) => {
        let key = skill?.ability_id;
        if (!key) {
            return false;
        }
        let dom = document.getElementById(key);
        if (!dom || !skill.apart) {
            return false;
        }
        changeHorizonDomIntoView(dom, boxRef.current);
    };
    useEffect(() => {
        changeScroll(curSkill);
    }, [curSkill?.ability_id]);
    const handleChangeTool = (tool) => {
        let dom = document.getElementById(tool.id);
        if (!dom) {
            return false;
        }
        changeHorizonDomIntoView(dom, boxRef.current);
        changeTool(tool);
    };
    return (
        <div ref={boxRef} className={s['top-skill-box']}>
            {skillList.map((item, index) => {
                return (
                    <div
                        id={item.ability_id}
                        className={s['list-item']}
                        data-active={!curToolId && isApartSkillActive(curSkill, item, isNewChat, true)}
                        key={index}
                        onClick={() => handleSetCurSkill(item)}
                    >
                        {item.ability_name}
                    </div>
                );
            })}
            {toolList.map((item, index) => {
                return (
                    <div
                        id={item.id}
                        className={s['list-item']}
                        data-active={curToolId === item.id}
                        key={index}
                        onClick={() => {
                            handleChangeTool(item);
                        }}
                    >
                        {item.name}
                    </div>
                );
            })}
        </div>
    );
};

export default inject('store')(observer(TopSkillList));
